/* @generated */

// src/assets/ui-icon/line/comment-read.tsx
import * as React from "react";
var CommentReadLine = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props }, /* @__PURE__ */ React.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5 6.75c0-.45.04-.867.121-1.25H6.25A2.25 2.25 0 0 0 4 7.75v7A2.25 2.25 0 0 0 6.25 17H7v2.492L11.736 17h6.014A2.249 2.249 0 0 0 20 14.75v-3.871c-.383.08-.8.121-1.25.121a7.09 7.09 0 0 1-.25-.004v3.754a.75.75 0 0 1-.75.75h-6.386L8.5 17.008V15.5H6.25a.75.75 0 0 1-.75-.75v-7A.75.75 0 0 1 6.25 7h8.254a7.089 7.089 0 0 1-.004-.25Zm-1 5.25H9v1.5h4.5V12ZM15 9v1.5H9V9h6Z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.75 4C16.977 4 16 4.977 16 6.75c0 1.773.977 2.75 2.75 2.75 1.773 0 2.75-.977 2.75-2.75 0-1.773-.977-2.75-2.75-2.75Zm0 4c-.841 0-1.25-.409-1.25-1.25s.409-1.25 1.25-1.25S20 5.909 20 6.75 19.591 8 18.75 8Z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke"
  }
));
export {
  CommentReadLine
};
